import mqtt from 'mqtt';

const options = {
    clientId: 'react-client-' + Math.random().toString(16).substr(2, 8),
    username: "root",
    password: "mqtt@123a",
    rejectUnauthorized: true,
};

//const mqttClient = mqtt.connect("mqtt://128.199.139.198:9001", options);
//const mqttClient = mqtt.connect("wss://thana.la:8884/mqtt", options);  // port: 8083 is use for websocket
//const mqttClient = mqtt.connect("wss://test.mosquitto.org:8081");  // port: 8083 is use for websocket


// MQTT connection options with SSL
const options_123 = {
    host: 'thana.la',
    port: 8884,
    protocol: 'wss',
    clientId: 'react-client-' + Math.random().toString(16).substr(2, 8),
    username: "root",
    password: "mqtt@123a",
    rejectUnauthorized: true, // set to true if you have valid CA
};

const mqttClient = mqtt.connect(options_123);

/*
mqttClient.on('connect', () => {
    //logger.debug('Connected to MQTT broker...');
    console.log('Connected to MQTT broker...')
});
*/

// Error handling
mqttClient.on('error', (err) => {
    //console.error('Connection error:', err);
});

mqttClient.on('close', () => {
    //console.log('Connection closed');
});

export default mqttClient;